import * as TYPES from './action-types';
// 应用
export default {
	state: {
		cityId: null,
		cityName: '',
		wxPayInfo: '',
		ticketInfoId: null,
	},
	getters: {
		cityId: state => state.cityId,
		cityName: state => state.cityName,
		wxPayInfo: state => state.wxPayInfo,
		ticketInfoId: state => state.ticketInfoId,
	},
	mutations: {
		[TYPES.APP__SET_CITY_ID](state, payload) {
			state.cityId = payload;
		},
		[TYPES.APP__SET_CITY_NAME](state, payload) {
			state.cityName = payload;
		},
		[TYPES.APP__SET_WX_PAY_INFO](state, payload) {
			state.wxPayInfo = payload;
		},
		[TYPES.APP_SET_TICKET_INFO_ID](state, payload) {
			state.ticketInfoId = payload;
		}
	},
	actions: {
		[TYPES.APP__SET_CITY_ID]({commit}, payload) {
			commit(TYPES.APP__SET_CITY_ID, payload);
		},
		[TYPES.APP__SET_CITY_NAME]({commit}, payload) {
			commit(TYPES.APP__SET_CITY_NAME, payload);
		},
		[TYPES.APP__SET_WX_PAY_INFO]({commit}, payload) {
			commit(TYPES.APP__SET_WX_PAY_INFO, payload);
		},
		[TYPES.APP_SET_TICKET_INFO_ID]({commit}, payload) {
			commit(TYPES.APP_SET_TICKET_INFO_ID, payload);
		}
	}
};
